export default {
    // banner
    'career.banner.title': `Make fun make sense`,
    'career.banner.description': 'Join us in this journey!',
    'career.banner.buttonText': `View Jobs`,
    // content 1
    'career.content1.title': 'Want to be a part of it?',
    'career.content1.description': `Our belief is that being simple, honest, self-driven and motivated combined with the constant pursuit of the ultimate company atmosphere can help grow a creative and robust team. `,
    // content 2
    'career.content2.1.title': 'Maria',
    'career.content2.1.subtitle': `Unity 3D Programmer`,
    'career.content2.1.description': `“I love being able to create amazing games with like-minded folks here at Habby!”`,
    'career.content2.2.title': 'Joel',
    'career.content2.2.subtitle': `Game Operator`,
    'career.content2.2.description': `“Habby provides a working atmosphere that’s equal, free and loving! It’s great to find yourself and improve yourself here.”`,
    // content 3
    'career.content3.title': 'Where are we',
    'career.content3.description': `We currently have offices in Singapore and Beijing will further grow to other destinations in the future.`,
    'career.content3.location.1.title': 'Beijing, CHN',
    'career.content3.location.1.desc': '10 Positions',
    'career.content3.location.2.title': 'Singapore, SG',
    'career.content3.location.2.desc': '6 Positions',
    // content 4
    'career.content4.modal.applyButtonText': 'Apply',
    'career.content4.title': 'We are hiring',
    'career.content4.description': `If you wish to apply for any of the above roles, please reach out with your Resume/CV to`,
    'career.content4.description.email': 'zhangxinzhe@habby.com',
    'career.content4.jobs.buttonText': 'Details',
    'career.content4.jobs': [
        {
            title: '国内手游运营经理',
            location: '北京',
            type: '运营',
            descriptions: [
                {
                    title: '岗位职责',
                    content:
                        '1、负责产品的发行和整体运营工作,制定相应的产品发行计划、运营实施规划、产品策略等,组织实施,对产品营收负责;\n2、负责规划手机游戏各阶段的线上线下活动以及活动专题的设计和制作,监督实施并进行效果报告统计分析;\n3、负责游戏产品数据分析,了解竞品对手产品市场信息,制定战略措施, 不断优化,打造产品核心竞争力;\n4、及时了解和分析用户情况、游戏在线运营情况,与研发、设计、测试团队协作,推动产品的开发、上线和版本迭代。'
                },
                {
                    title: '岗位要求',
                    content:
                        '1、全日制统招本科及以上学历,专业不限;\n2、5年及以上游戏运营相关工作经验,其中至少2年以上手游运营管理经验,国内海外地区不限;\n3、深入理解轻中度游戏优先,有策划经验优先,有Top50畅销游戏运营经验优先,有百万量级DAU游戏（不包含超休闲）运营经验优先;\n4、具备良好的沟通协调能力、项目管理能力及文案书写能力;\n5、具有较强的抗压精神和工作责任心,热爱游戏行业,期望长期在游戏行业发展。'
                },
            ]
        },
        {
            title: 'U3D客户端开发',
            location: '北京',
            type: '研发',
            descriptions: [
                {
                    title: '专业技能',
                    content:
                        '1. 4年以上unity前端逻辑开发经验;\n2. 熟练掌握UGUI的使用,对UGUI有深入的理解;\n3. 熟练使用Unity进行扩展工具的开发;\n4. 熟练掌握lua脚本;'
                },
                {
                    title: '综合素质',
                    content:
                        '1. （重要）有丰富的业务逻辑设计和开发经验,善于优化和重构业务相关逻辑结构;\n2. 逻辑思维能力强,学习能力强,品质导向\n3. 对技术原理有深刻的思考\n4. 具有良好的沟通能力,善于表达自己的观点\n5.能够快速进行框架搭建和原型设计。'
                }
            ]
        },
        {
            title: '游戏客户端开发-技术中台',
            location: '北京',
            type: '研发',
            descriptions: [
                {
                    title: '职位描述',
                    content:
                        '1. 负责游戏性能优化,包括但不限于帧率,内存占用,发热,网络延时等;\n2. 完善性能检测,分析,监控等工具链,保证客户端性能维持稳定;\n3. 定制渲染管线,规划项目的渲染流程和效果;\n4. 配合美术搭建资源生产流程.'
                },
                {
                    title: '任职要求',
                    content:
                    '1. 精通C#语言,熟悉C++语言;\n2. 逻辑清晰,善于解剖分析问题\n3. 熟悉计算机图形学\n4. 具备扎实的计算机基础,熟练使用至少一门编程语言,有性能优化工作经验、熟练掌握各种profile工具者优先\n5. 良好的沟通和协作能力,能够在跟策划、美术、QA的日常沟通和合作中觉察到可优化项'
                },
            ]
        },
        {
            title: '游戏技术TA',
            location: '北京',
            type: '研发',
            descriptions: [
                {
                    title: '职位描述',
                    content: '1. 负责游戏的引擎优化,开发组件和工具,满足项目功能需求\n2. 负责游戏性能优化,平衡手机各核心负载的同时,控制发热\n3. 定制渲染管线,规划项目的渲染流程,优化渲染算法'
                },
                {
                    title: '任职要求',
                    content: 
                        '1. 精通C#语言,熟悉C++语言;\n2. 逻辑清晰,善于解剖分析问题\n3. 熟悉计算机图形学\n4. 具备扎实的计算机基础,熟练使用至少一门编程语言,有性能优化工作经验、熟练掌握各种profile工具者优先\n5. 良好的沟通和协作能力,能够在跟策划、美术、QA的日常沟通和合作中觉察到潜在性能风险'
                },
            ]
        },
        {
            title: '资深游戏测试',
            location: '北京',
            type: '测试',
            descriptions: [
                {
                    title: '岗位职责',
                    content:
                        '1、负责移动游戏产品测试,快速响应测试需求,保证测试业务有序开展\n2、在测试过程中,迅速、准确、全面的找出游戏中的问题,并对问题产生原因做基本判断\n3、熟悉项目开发及测试流程与各种测试技巧,熟悉测试用例及测试文档,测试报告的编写\n4、数据驱动,优化测试全流程,梳理测试标准,提升测试质量和效率\n5、研究测试技术、推动测试工具的设计研发,提升测试团队战斗力'
                },
                {
                    title: '职位要求',
                    content:
                        '1、计算机相关专业,本科及以上学历,5年及以上测试行业经验\n2、有较强的逻辑分析能力和学习能力,自驱能力强,对项目质量负责,推动项目持续改进\n3、良好的技术能力,至少熟练掌握一种编程语言;有技术热情,积极了解测试领域的技术进展\n4、 对游戏有足够热情,能够接受并投入各类游戏的测试工作\n5、对个人看法能够精准描述;做事认真仔细、有耐心,踏实稳重,有良好的语言表达能力的协作沟通能力及逻辑思维能力,工作责任心强'
                }
            ]
        },
        {
            title: '游戏运营宣传设计师',
            location: '北京',
            type: '运营',
            descriptions: [
                {
                    title: '岗位描述',
                    content:
                        '1. 和运营团队紧密配合,讨论和推进创意,负责上线游戏的运营活动的物料设计\n2. 使用现有项目的美术资源,结合自身美术能力,表达创意,创作出不同场景需求使用的插图或者平面设计\n3. 根据结果总结积累经验,优化设计和效率\n4.与外包团队沟通协作,能独立把控外包设计质量和进度\n5.快速学习了解新的工具和方法,提升效率和质量,应用到实际项目'
                },
                {
                    title: '总体要求',
                    content: 
                        '热情+自驱 + 高审美 + 有趣\n1. 审美好,创意能力强,做出能打动玩家的设计\n2. 具备出色的平面设计能力和一定的插画水准（辅助创意）,具备用不多的游戏资源设计出高品质运营宣传图的能力\n3. 擅长欧美卡通方向\n4. 强目标感,有明确追求的方向,对自己所做有高品质要求\n5. 自发推进,可以在一个开放自由的工作环境工作推进出好的结果\n6. 开放意识和心态,接受新的方法,工具和优化现有的工作模式\n7. 思维表达清晰,沟通简单高效且逻辑清楚\n8. 了解并熟悉常用AI绘图工具,如SD、MJ等\n9. 对游戏有着浓厚的热情,对Habby游戏有热情为佳'
                }
            ]
        },
        {
            title: '中级UI设计师（中台）',
            location: '北京',
            type: '美术',
            descriptions: [
                {
                    title: '岗位职责',
                    content:
                        '1.热爱游戏,对现在当下流行的游戏风格有个人理解和看法;\n2. 和团队紧密配合,依照一个既定风格根据需求推导后续设计,并且对设计质量和产品负责;\n3. 有关于UI/UX场景领域积淀的方法论和经验,并运用其有效的满足需求完成高质量的UI设计;\n4. 具备产品思维,擅长与产品策划沟通寻求最佳设计解决方案。'
                },
                {
                    title: '任职要求',
                    content:
                        '1. 擅长欧美卡通方向的UI风格;\n2. 强目标感,有明确追求的方向,对自己所做有品质的要求;\n3. 自发推进,可以在一个开放自由的工作环境工作并且对结果负责;\n4. 开放意识和心态,接受新的方法和优化现有的工作模式;\n5. 思维表达清晰,沟通逻辑清楚;\n6. 重视方法论的积淀总结;\n7. 有大公司和成功项目的经验优先。'
                }
            ]
        },
        {
            title: '游戏TA(美术向)',
            location: '北京',
            type: '美术',
            descriptions: [
                {
                    title: '岗位职责',
                    content:
                        '1. 项目初期按照制作人要求搭建符合Demo风格的3D场景和角色效果(没有原画设计,只有需求描述) ; \n&nbsp;- 场景模型制作以及unity场景搭建, 材质调整和氛围调试 ; \n- 角色模型和贴图制作以及unity材质效果 ; \n- 配合策划和程序同学推进Demo的进度 ; \n2. 寻找符合的3D素材或者直接制作3D资源 ; \n3. 动作接入引擎(有动作同学帮助) ; \n4. 特效接入引擎(有特效同学帮助) 。'
                },
                {
                    title: '岗位描述',
                    content:
                        '1.配合项目Demo制作符合项目要求的美术资源;\n2. 负责Demo中的模型和材质制作。'
                },
                {
                    title: '任职要求',
                    content:
                        '1. 能够熟练使用unity的模型材质灯光等模块;\n2. 熟练掌握unity的shader编写(Build-in和URP);\n3. 了解unity的动画和特效模块;\n4.（有PBR制作能力或三渲二项目经验者优先）。'
                },
                {
                    title: '总体要求',
                    content:
                        '1. 擅长偏欧美卡通方向,审美高;\n2. 强目标感,有明确追求的方向,对自己产出有品质的要求;\n3. 自发推进,可以在一个开放自由的工作环境工作并且对结果负责;\n4. 开放意识和心态,接受新的方法和优化现有的工作模式;\n5. 思维表达清晰,沟通简单且逻辑清楚;\n6. 对游戏有着浓厚的热情,有自己对于游戏的理解,对Habby游戏有热情为佳。'
                }
            ]
        },
        {
            title: '游戏AI训练师',
            location: '北京',
            type: '研发',
            descriptions: [
                {
                    title: '工作内容',
                    content:
                        '1. 为游戏研发提供专业建议、规则梳理等保障,\n2. 与项目组深入沟通,形成对实际业务有较高提升的需求,形成工作方向;\n3. 熟练使用DE2、MJ、SD等主流AI;根据需要完成多种风格的探索并形成方法 论;\n4. 培训内部有需要使用AI的成员,保证其在现有岗位上的使用。'
                },
                {
                    title: '任职要求',
                    content:
                        `1. 对AI保持热情、心态开放;\n2. 熟练掌握AI训练方法,特别是特定模型训练的学习方法,以及混合模型的使用方法;\n3. 有AI训练师从业经历优先;\n4. 熟悉并了解AI社区优先;\n5. 有非常强的分析能力,较强的沟通协调表达能力;\n6.热爱游戏行业。\n`
                }
            ]
        },
        {
            title: '游戏AI算法工程师',
            location: '北京',
            type: '研发',
            descriptions: [
                {
                    title: '岗位职责',
                    content:
                    '1.负责游戏AI的算法研究,结合游戏应用场景,提供技术解决方案;\n2.跟踪业界最新进展,研究AIGC相关技术,构建领先业界的技术壁垒;\n3.通过AIGC解决协作项目在视觉、音频、文字生成方面的具体需求,提出解决方案,并协助项目实施。\n4.负责AIGC顶目的模型搭建和落地工作;\n5.结合产品需求,从prompt优化、模型Finetune等方面优化AI绘画、AI文字生成的效果。\n'
                },
                {
                    title: '任职要求',
                    content:
                        '1.熟练使用tensorflow或者其他深度学习框架;\n2.本科以上学历,985/211/海外CS名校优先;\n3.具有良好的沟通、协作能力和丰富的团队工作经验,逻辑思维清晰;4.热爱游戏,酷爱设计工作,具有创新精神,及较强的学习能力。\n'
                }
            ]
        },
        // {
        //     title: 'Localization QA Tester (English/Japanese/Korean)',
        //         location: 'Singapore',
        //         type: 'Tester',
        //         descriptions: [
        //             {
        //                 title: 'Job Responsibilities',
        //                 content:
        //                     `1. Prepare test strategy and execute accordingly; \n2. Provide feedback for LQA procedure enhancement during project lifecycle; \n3. Ensure correct terminologies are used in accordance with the target market;\n4. Ensures defects/issues are raised & follow through and notify LQA team immediately on all critical issues; \n5. Ensure the in-game LQA are finished on time and help with emergent translation request; \n6. Other duties as assigned.`
        //             },
        //             {
        //                 title: 'Requirements',
        //                 content:
        //                     `1. Excellent written and verbal communication skills in English, Korean and/or Japanese (Native speaker is preferred); \n2. Experience in localization and/or video games industry is preferred; \n3. Outstanding attention to detail and ability to work with tight deadlines; \n4. Passion in gaming!\n`
        //             }
        //         ]
        // },
        {
            title: 'Marketing Executive (Korean Speaking)',
            location: 'Singapore',
            type: 'Executive',
            descriptions: [
                {
                    title: 'Job Responsibilities',
                    content:
                        `1. Management of social media platforms such as Facebook and Twitter for multiple projects.; Including but not limited to: content creation, news updating, players/community sentiments monitoring and share the feedback with the team; \n2. Aware of hot and trending topics in the game industry on mainstream social platforms; Organize online and offline campaigns to promote the games and maintain players' engagement; Analyze campaigns' efficacy and provide relevant reports; \n3. Response and engage with the audience on social media platforms in Korean; \n4. Implementation of marketing plans – Making plans and coordinating with Korean influencers; \n5. Other duties as assigned (Game localization etc.) \n`
                },
                {
                    title: 'Requirements',
                    content:
                        `1. Fluent in Korean (minimum request: TOPIK II Lv6); \n2. Bachelor's degree or above; Understand game markets and related products; - Preferably familiar with the Korean game market; \n3. Having logical solid thinking ability and basic marketing knowledge; Being active and creative; \n4. Effective communication skills and robust data analysis ability\n`
                }
            ]
        },
        // {
        //     title: 'Localization Manager',
        //     location: 'Singapore',
        //     type: 'Manager',
        //     descriptions: [
        //         {
        //             title: 'Job Responsibilities',
        //             content:
        //                 `1. Coordinating with multiple parties to make sure that all translators are on track with project requirements, deadlines, and schedules; \n2. Serving as a point of contact for teams when multiple projects are running to ensure team actions remain in synergy; \n3. Adjust the schedule and target on the project as needed when encountering changes without compromising the development teams’expectations and schedule set out; \n4. Communicating with the translators to keep the work aligned with the handover schedule and ensure correct terminologies are used in accordance with the target market; \n5. Delegate tasks to the translators who are best positioned to complete them; \n6. In charge of all appropriate paperwork such as quotations, and internal sign-off for the project; \n7. Other duties as assigned.\n`
        //         },
        //         {
        //             title: 'Requirements',
        //             content:
        //                 `1. Excellent written and verbal communication skills in English and knowledge of Korean and/or Japanese; \n2. At least 3 years of experience in localization and/or video games industry is a must; \n3. Able to independently manage the LQA procedure and be the key person in-charge and point of contact for LQA-related cases; \n4. A problem solver; Experienced and familiar with game LQA procedure; \n5. Be able to manage project costing and be familiar with prices; Control the cost and expenses of the project; \n6. Possess strong multitasking skills to work on multiple projects concurrently.\n`
        //         }
        //     ]
        // },
        // {
        //     title: 'Game Graphic Designer',
        //     location: 'Singapore',
        //     type: 'Designer',
        //     descriptions: [
        //         {
        //             title: 'Job Responsibilities',
        //             content:
        //                 `1. Collaborate with the marketing team to conceptualize, design, and produce marketing materials for a variety of channels, including social media, marketing and advertising; \n2. Develop illustrations, graphic design, and others by software; \n3. Open to feedback and resolve design challenges; \n4. Ensure the finalized works are visually appealing and in line with the brand image; \n5. Optimize the process and efficiency based on cases and by new tools and methods; 6. Other duties as assigned. \n`
        //         },
        //         {
        //             title: 'Requirements',
        //             content:
        //                 `1. At least 2 years of graphic designing experience;\n2. A keen awareness for aesthetics and strong creativity to produce attractive visuals for players;\n3. A strong portfolio of illustrations or other graphic design works and able to create appealing graphics with limited resources;\n4. Familiar with the western game art style;\n5. Strong self-motivation and high self-demand; \n6. Excellent communication skills; \n7. Great passion for HABBY games is a plus.\n`
        //         }
        //     ]
        // },
        {
            title: 'Marketing Executive (Japanese Speaking)',
            location: 'Singapore',
            type: 'Executive',
            descriptions: [
                {
                    title: 'Job Responsibilities',
                    content:
                        `1. Management of social media platforms such as Facebook and Twitter for multiple projects.; Including but not limited to: content creation, news updating, players/community sentiments monitoring and share the feedback with the team; \n2. Aware of hot and trending topics in the game industry on mainstream social platforms; Organize online and offline campaigns to promote the games and maintain players' engagement; Analyze campaigns' efficacy and provide relevant reports; \n3. Response and engage with the audience on social media platforms in Japanese; \n4. Implementation of marketing plans – Making plans and coordinating with Japanese influencers; \n5. Other duties as assigned (Game localization etc.) \n`
                },
                {
                    title: 'Requirements',
                    content:
                        `1. Fluent in Japanese (minimum request: JLPT N1); \n2. Bachelor's degree or above; Understand game markets and related products; - Preferably familiar with the Japanese game market; \n3. Having logical solid thinking ability and basic marketing knowledge; Being active and creative;\n4. Effective communication skills and robust data analysis ability.\n`
                }
            ]
        },
        // {
        //     title: 'Game Marketing Strategist',
        //     location: 'Singapore',
        //     type: 'Operator',
        //     descriptions: [
        //         {
        //             title: 'Job Responsibilities',
        //             content:
        //                 `1. Responsible for company’s global marketing strategy, including exploring KOL cooperation models on various platforms such as YouTube, Instagram, Tiktok, and Twitch, and providing timely data review and project closure reports;\n2. Monitor the marketing performance data and collaborate with creative and operation teams to come out with better and more efficient advertising strategies; \n3.Responsible for liaison with different marketing agents or channels, data reconciliation of key promotion accounts and contract follow-up, etc. \n`
        //         },
        //         {
        //             title: 'Requirements',
        //             content:
        //                 `1. Bachelor’s degree or above, excellent written and verbal communication skills in English and knowledge of Japanese will be a plus; \n2. With good market and industry observation and insights, able to integrate resources and track market trends and continue to tap on local resources; \n3. Excellent learning ability, open-minded attitude and good at analyzing and solving problems independently.`
        //         }
        //     ]
        // },
        // 2023.5.17 新增
        {
            title: 'Senior Game Programmer',
            location: 'Singapore',
            type: 'Developer',
            descriptions: [
                {
                    title: 'Job Responsibilities',
                    content:
                        `1.Responsible for game performance optimization, including but not limited to frame rate, memory usage, heat generation, and network latency.\n2.Improving performance testing, analysis, and monitoring tools to ensure stable client performance.\n3.Customizing rendering pipelines and planning project rendering processes and effects.\n4.Cooperating with artists to build a resource production process.`
                },
                {
                    title: 'Requirements',
                    content:
                        `1.Proficient in C# language and familiar with C++ language.\n2.Clear logic skills with the ability to analyze and solve problems.\n3.Familiarity with computer graphics.\n4.Solid computer foundations with proficiency in at least one programming language. Prior experience in performance optimization and proficiency in various profile tools is preferred.\n5.Good communication and collaboration skills, able to identify optimization areas during daily communication and cooperation with planners, artists, and QA.`
                }
            ]
        },
        {
            title: 'Senior Server Programmer',
            location: 'Singapore',
            type: 'Developer',
            descriptions: [
                {
                    title: 'Job Responsibilities',
                    content:
                        `The Game Server Developer will be responsible for the architecture and development of the game server for HABBY 's games.`
                },
                {
                    title: 'Requirements',
                    content:
                        `1.Solid foundation in Java/Golang, familiar with concurrent programming and network programming.\n2.Proficiency in the Netty network framework, understanding of mainstream development frameworks such as Spring or Gin.\n3.Proficiency in DynamoDB/MongoDB/MySQL databases with experience in data modeling design and performance optimization.\n4.Familiarity with commonly used open-source distributed middleware, caching, message queues, etc.\n5.Familiarity with commonly used Linux system commands and operations.\n6.Passionate about the internet and technology with excellent coding skills, code style, habits, communication skills and teamwork collaboration abilities.\n7.Three or more years of working experience.`
                },
                {
                    title: 'Additional Qualifications',
                    content:
                        `1.Familiarity with AWS/Aliyun cloud platforms and has unique insights into cloud service usage.\n2.Familiarity with at least one script language.\n3.Experience in developing high load / distributed systems is preferred.\n4.Contributed to open-source projects.`
                },
            ]
        },
        {
            title: 'Artificial Intelligence Trainer (Gaming)',
            location: 'Singapore',
            type: 'Operator',
            descriptions: [
                {
                    title: 'Job Responsibilities',
                    content:
                        `1.Provide professional advice and guidance on game development, including rule setting and other technical support;\n2.Communicate and identify the needs of the development teams to provide guidance for their projects;\n3.Proficient in using the main AI platforms such as Midjourney and Stable Diffusion; 4.Come up with suitable methods for various art styles as required;\n5.Train the employees who need to use AI for their current work.`
                },
                {
                    title: 'Requirements',
                    content:
                        `1.Passionate and open-minded towards AI technology;\n2.Proficient in AI training methods, especially for specific model training, and usage of mixed models;\n3.Previous experience as an AI trainer is preferred;\n4.Familiarity with AI communities is preferred;\n5.Strong analytical skills; Excellent communication and coordination ability;\n6.Passion for the AIGC industry.`
                }
            ]
        },
        // 应届生
        {
            title: 'Game Programmer（Graduates）',
            location: 'Singapore',
            type: 'Developer',
            descriptions: [
                {
                    title: 'Job Responsibilities',
                    content:
                        `1.Develop features for mobile games based on the Unity3D engine;\n2.Assist in developing game-related extension kits, engine application components, and engine component library construction;\n3.Responsible for the development of game client-related logic.`
                },
                {
                    title: 'Requirements',
                    content:
                        `1.Diploma or above in a computer-related major; game demo production experience required;\n2.Proficient in U3D engine architecture design and object-oriented programming in C#, Lua, C++, and Java, with strong logical thinking ability;\n3.Familiarity with basic algorithms, such as physics algorithms, and knowledge about computer graphics, Unity graphic processing processes, and Unity rendering optimization-related work;\n4.Passionate about games, loves life, and eager to make successful games.`
                }
            ]
        },
        {
            title: 'Game Designer（Graduates）',
            location: 'Singapore',
            type: 'Designer',
            descriptions: [
                {
                    title: 'Job Responsibilities',
                    content:
                        `1.Responsible for designing the game's core gameplay systems, functions, social interaction, and tasks.\n2.Responsible for participating in game experience and gameplay, system framework construction, program design, production follow-up, test verification, and adjustment/optimization; also responsible for producing related documents.\n3.Cooperating with art and programming departments to realize the design plan.\n4.Responsible for follow-up, adjustment and optimization of game launch effects and continuous optimization of game core and basic systems, functions, copywriting, etc.`
                },
                {
                    title: 'Requirements',
                    content:
                        `1.Diplomaor above, with a deep passion for the game industry. Game demo production experience is required.\n2.Strong logical thinking ability, analytical skills, active thinking, imagination, and creativity.\n3.Strong writing/documentation skills with the ability to work under pressure and to set high standards for themselves.`
                }
            ]
        },
        {
            title: 'Game Artist（Graduates）',
            location: 'Singapore',
            type: 'Operator',
            descriptions: [
                {
                    title: 'Job Responsibilities',
                    content:
                        `1.Participate in the game art design, including character design, scene design, animation, UI design, etc.\n2.Work closely with game planners and programmers to ensure the quality and effectiveness of the game's artistic design.\n3.Continuously improve the artistic level of the game and optimize details to enhance the user experience.\n4.Complete assigned tasks efficiently and on-time.`
                },
                {
                    title: 'Requirements',
                    content:
                        `1.Diplomaor in art, design or related field with a game demo production experience required.\n2.Strong aesthetic sense, with a keen understanding of color, composition, and space.\n3.Proficiency in using at least one mainstream design software such as Photoshop, Illustrator, Sketch, Procreate, etc.\n4.Passionate about the game industry and willing to constantly learn and improve.Able to take constructive criticism and feedback positively and work well under pressure.`
                }
            ]
        },
    ]
};
